export const INFRA_MAP_API = '/infra-dashboard';
export const INFRA_MAP_REFRESH_API = '/infra-dashboard/refresh';

// redux
export const INFRA_MAP_STORE = 'infraMap';
export const INFRA_MAP_STORE_LIST = 'list';
export const INFRA_MAP_STORE_REFRESH = 'refresh';
